<svg
	fill="currentColor"
	viewBox="0 0 100 100"
	xmlns="http://www.w3.org/2000/svg"
	class={$$restProps.class || ''}
>
	<circle cx="50" cy="50" r="50" />
</svg>
